import { channelPartnerWebhookQueryKeys as e } from "./useChannelPartnerWebhookQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { adminChannelPartnerWebhooksApi as r } from "@maat/api-main";
//#region src/channelPartnerWebhooks/useRedriveChannelPartnerDeliveryMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: (e) => r.redriveDelivery(e),
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.deliveries() }), i.invalidateQueries({ queryKey: e.deliveryStats() });
		}
	});
};
//#endregion
export { i as useRedriveChannelPartnerDeliveryMutation };
